export const getIsValidDate = (date: string | undefined): date is string =>
  !isNaN(Date.parse(date as string));
